import { ANCHORTARGETS } from '../../../enums/ANCHORTARGETS.js';
import { HTMLELEMENT } from '../../../enums/HTMLELEMENT.js';
import SPAN, { EL } from '../../DOM/span/SPAN.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { ANCHORREL } from '../../../enums/ANCHORREL.js';
// Model Structure
export const aAttr = makeAttrStruct([
    ['href', ''],
    ['target', ANCHORTARGETS.SELF],
    ['rel', ANCHORREL.NONE]
]);
export const aData = makeDataStruct([
    ['text']
]);
export const aModel = makeStruct([
    ['attributes', aAttr],
    ['data', aData]
]);
// Simplified Model
export function a(text, href, target, rel) {
    return {
        attributes: aAttr(href, target, rel),
        data: aData(text)
    };
}
/** A hyperlink / page anchor */
export default class A extends EL {
    constructor(node, model) {
        super(node, HTMLELEMENT.A, model);
    }
    setHref(href) {
        this.setAttribute('href', href);
        this.el.setAttribute('href', href);
    }
    /** Sets the target for this anchor */
    setTarget(target) {
        this.setAttribute('target', target);
        this.el.setAttribute('target', target);
    }
}
export { ANCHORTARGETS, EL, SPAN };
